import React from 'react';
import { S9PressRelease, S9PressReleaseProps, MilanGradientColors, MilanBackgroundColors } from '@milanlaser/mlcomponents';
import { processBackgroundAndGradientColorMap } from '../../utils/builder.utils';
import { PaddingSize, paddingMap } from '../../utils/builderPaddingOptions';

type PressReleaseCard = {
  title: string;
  pressReleaseDate: string;
};

interface S9PressReleaseArgs extends Omit<S9PressReleaseProps, 'cards' | 'backgroundColor' | 'backgroundGradient' | 'cardBackgroundGradient' | 'cardBackgroundColor'> {
  desktopPaddingTop: PaddingSize;
  desktopPaddingBottom: PaddingSize;
  mobilePaddingTop: PaddingSize;
  mobilePaddingBottom: PaddingSize;
  cards: PressReleaseCard[];
  backgroundColor?: string;
  backgroundGradient: MilanGradientColors | 'None';
  cardBackgroundGradient?: MilanGradientColors | 'None';
  cardBackgroundColor?: string;
  cardBackgroundImage?: string;
  backgroundImage?: string;
}

export function S9PressReleaseSection(props: S9PressReleaseArgs) {
  const {
    desktopPaddingTop,
    desktopPaddingBottom,
    mobilePaddingTop,
    mobilePaddingBottom,
    cards,
    backgroundColor,
    backgroundGradient,
    cardBackgroundGradient,
    cardBackgroundColor,
    cardBackgroundImage,
    backgroundImage,
    ...restProps
  } = props;

  const topPaddingClasses = `mcl-pt-${paddingMap[mobilePaddingTop]} lg:mcl-pt-${paddingMap[desktopPaddingTop]}`;
  const bottomPaddingClasses = `mcl-pb-${paddingMap[mobilePaddingBottom]} lg:mcl-pb-${paddingMap[desktopPaddingBottom]}`;

  const processedBackgroundColor = backgroundColor === 'None' ? 'White' : backgroundColor;
  const processedBackgroundGradient = backgroundGradient === 'None' ? '' : backgroundGradient;
  const processedCardBackgroundGradient = cardBackgroundGradient === 'None' ? '' : cardBackgroundGradient;
  const processedCardBackgroundColor = cardBackgroundColor === 'None' ? '' : cardBackgroundColor;

  const modifiedProps = {
    ...restProps,
    cards: cards,
    backgroundColor: (processedBackgroundColor || 'White') as MilanBackgroundColors,
    backgroundGradient: processedBackgroundGradient as MilanGradientColors,
    cardBackgroundGradient: processedCardBackgroundGradient as MilanGradientColors,
    cardBackgroundColor: processedCardBackgroundColor as MilanBackgroundColors,
    cardBackgroundImage,
    backgroundImage,
    className: `${topPaddingClasses} ${bottomPaddingClasses}`,
  };

  const backgroundColorClass = processBackgroundAndGradientColorMap({
    backgroundColor: (processedBackgroundColor as MilanBackgroundColors) || 'White',
    gradientColor: processedBackgroundGradient || 'None',
  });

  return (
    <div className={`${backgroundColorClass}`}>
      <S9PressRelease
        {...modifiedProps}
      />
    </div>
  );
}
